<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="10" cy="10" r="10" :fill="invert?color:color2"/>
  <svg x="4" y="4" width="12" height="12" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.3015 0H2.69852C1.2068 0.00380513 -0.000423253 1.21257 1.11319e-07 2.70227V12.2774C-0.000423253 13.7672 1.2068 14.9759 2.69852 14.9797H12.3015C13.7932 14.9761 15.0004 13.7672 15 12.2774V2.70227C15.0004 1.21257 13.7932 0.00380513 12.3015 0ZM4.1894 1.22779H10.8106V4.1144C10.8106 4.49745 10.462 4.80926 10.0335 4.80926H4.96648C4.53783 4.80926 4.1894 4.49745 4.1894 4.1144V1.22779ZM13.7737 12.2774C13.7739 13.0903 13.1152 13.7498 12.3015 13.7519H2.69852C1.88461 13.7498 1.22606 13.0903 1.22627 12.2774V2.70227C1.22606 1.88946 1.88461 1.2299 2.69852 1.22779H2.96312V4.1144C2.96312 5.17455 3.86193 6.03662 4.96648 6.03662H10.0333C11.1379 6.03662 12.0367 5.17412 12.0367 4.1144V1.22779H12.3013C13.1152 1.2299 13.7737 1.88946 13.7735 2.70227V12.2774H13.7737ZM9.43467 4.19536C9.59745 4.19515 9.75346 4.13025 9.86862 4.01525C9.98356 3.90004 10.0481 3.74403 10.0477 3.58147V2.39617C10.0505 2.17569 9.93403 1.97084 9.7433 1.85986C9.55257 1.74888 9.31676 1.74888 9.12603 1.85986C8.93531 1.97084 8.81888 2.17569 8.82164 2.39617V3.58147C8.82142 3.74403 8.88599 3.90004 9.00072 4.01525C9.11566 4.13025 9.27167 4.19494 9.43467 4.19536Z" :fill="invert?color2:color"/>
  </svg>
</svg>

</template>

<script>
export default {
  props: {
    invert: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 38
    },
    height: {
      type: Number,
      default: 38
    },
    color: {
      type: String,
      default: 'white'
    },
    color2: {
      type: String,
      default: 'var(--color-pri)'
    }
  }
}
</script>
